// src/store/rack/RackMinerStore.ts
import { MODALS_ENUM } from '@constants/Modals';
import { BackRackItemToUnrack_RequestTypes } from '@mobx/api/locations';
import { GetFullMinerInfo_RequestTypes } from '@mobx/api/miner';
import apiService, { createStore, RequestControl, withLoading } from '@mobx/services/http';
import store_ from '@store';
import { action, makeObservable, observable } from 'mobx';
import { show } from 'redux-modal';
import { getGlobalIntl } from '../../../i18n/ProviderIntl';
import { IItemStore, IMainLocationsStore, IRackMinerStore, IRackMinerStoreBase } from './interfaces';
import { IRackItem3, isRackItem3 } from './types';
import unallocatedMinersStore from './unallocated';

export const createRackMinerStore_ = (itemStore: IItemStore, mainStore: IMainLocationsStore) => (rc: RequestControl): IRackMinerStore => {
  const getFullMinerIinfo = apiService.createRequest(GetFullMinerInfo_RequestTypes);
  const putRackItemBackToUnrack = apiService.createRequest(BackRackItemToUnrack_RequestTypes);
  const rackItem = itemStore.item as IRackItem3;

  const self: IRackMinerStoreBase = {
    isLoading: false,

    // прообраз: onOpenMinerInfo в useMenuControl
    async openMinerInfo() {
      const handle = rc.createRequestHandle();
      const id = rackItem.miner_id ?? rackItem.id;
      if (id === undefined) return;
      const r = await withLoading(self, getFullMinerIinfo(handle, id));
      if (!r) return;
      store_()?.dispatch(
        show(MODALS_ENUM.MORE_INFO_MODAL, {
          miner: { ...r.Record, id: r.Record.Id },
        })
      );
    },

    async deleteMiner(itemIndex: number) {
      if (!mainStore.activeLocation?.activeBuilding) return;
      const buildingStore = mainStore.activeLocation.activeBuilding;
      const { formatMessage } = getGlobalIntl();

      const p = new Promise<void>(release => {
        const onConfirm = async () => {
          const handle = rc.createRequestHandle();
          const res = await withLoading(self, putRackItemBackToUnrack(handle, rackItem.id));
          if (!res) {
            release();
            return;
          }

          itemStore.turnToSection();
          unallocatedMinersStore.addMiner({...rackItem, id: rackItem.miner_id});
          buildingStore.setCanUndo();
          release();
        };  

        store_()?.dispatch(
          show(MODALS_ENUM.CONFIRM_MODAL, {
            title: " ",
            subtitle: `${formatMessage(
              { id: "location.rack.rack_item.delete_confirm" },
              { name: rackItem.miner_name }
            )}`,
            onConfirm,
          })
        ); 
      });

      return p;
    },

    isFilteredByUser(): boolean {
      if (!mainStore.activeLocation) return false;
      return mainStore.activeLocation.selectedUsers.has(+rackItem.user_id);
    },

    canDeleteMiner(): boolean {
      return !(rackItem.merge && rackItem.merge.length > 0);
    }
  };

  return makeObservable(self, {
    isLoading: observable,

    openMinerInfo: action,
    deleteMiner: action,
    isFilteredByUser: action,
    canDeleteMiner: action,
  });
};

const createRackMinerStore = (itemStore: IItemStore, mainStore: IMainLocationsStore) => {
  if (!isRackItem3(itemStore.item)) return;
  return createStore(createRackMinerStore_(itemStore, mainStore));
}

export default createRackMinerStore;